import {
  Driver,
  DriverField,
  DRIVER_RELATIONSHIP_OPTIONS,
} from '@insurgrid/common';
import states from 'states-us';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from './Input';
import { FormSelect } from './Select';

const STATE_OPTIONS = states.map((s) => {
  return {
    label: s.abbreviation,
    value: s.abbreviation,
  };
});

// Stored as the label itself rather than a code: owl keeps this column as free
// text because the same field also arrives from dec-page extraction, so there
// is no code table on the other side to map to (INS-1418).
const RELATIONSHIP_OPTIONS = DRIVER_RELATIONSHIP_OPTIONS.map((relationship) => ({
  label: relationship,
  value: relationship,
}));

export function FormDriversInput({
  name,
  defaultValue,
}: DriverField & { defaultValue?: Driver }) {
  const { setValue } = useFormContext();

  const defaultDob = defaultValue?.dateOfBirth
    ? dayjs(defaultValue.dateOfBirth, 'MM-DD-YYY').format('YYYY-MM-DD')
    : undefined;

  useEffect(() => {
    setValue(`${name}.dateOfBirth`, defaultDob);
  }, []);

  return (
    <div className="space-y-5">
      <div className="flex space-x-5">
        <Input
          data-test-id="driver-first-name"
          label="First name"
          name={`${name}.firstName`}
          defaultValue={defaultValue?.firstName}
        />
        <Input
          data-test-id="driver-last-name"
          label="Last name"
          name={`${name}.lastName`}
          defaultValue={defaultValue?.lastName}
        />
      </div>
      <Input
        data-test-id="driver-license-number"
        label="Driver's license number"
        name={`${name}.driverLicenseCode`}
        defaultValue={defaultValue?.driverLicenseCode}
      />
      <FormSelect
        data-test-id="driver-state"
        label="State"
        options={STATE_OPTIONS}
        name={`${name}.usStateCode`}
        defaultValue={defaultValue?.usStateCode}
        className="w-full"
      />
      <Input
        data-test-id="driver-dob"
        type="date"
        placeholder="MM-DD-YYYY"
        label="Date of birth"
        name={`${name}.dateOfBirth`}
        defaultValue={defaultDob}
        className="max-w-1/2"
      />
      <FormSelect
        data-test-id="driver-relationship"
        label="Relationship to policyholder"
        options={RELATIONSHIP_OPTIONS}
        name={`${name}.relationshipToPolicyholder`}
        defaultValue={defaultValue?.relationshipToPolicyholder ?? undefined}
        className="w-full"
      />
    </div>
  );
}
